/**
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URLs
 *  Length limitations (2022-06-08)
 *    Browsers are not required to support any particular maximum length of data.
 *    For example, the Opera 11 browser limited URLs to 65535 characters long
 *    which limits data URLs to 65529 characters (65529 characters being the
 *    length of the encoded data, not the source, if you use the plain data:,
 *    without specifying a MIME type). Firefox version 97 and newer supports
 *    data URLs of up to 32MB (before 97 the limit was close to 256MB).
 *    Chromium objects to URLs over 512MB, and Webkit (Safari) to URLs over
 *    2048MB.
 *
 */
const URL_MAX_SIZE = 32 * 1024 * 1024; // do no break firefox limit

/**
 *
 * @param the file fileUrl string. Example: `data:image/jpeg;base64,/......`
 */
export const urlToBlob = async (fileUrl: any): Promise<Blob | null> => {
  if (!fileUrl) return null;
  if (fileUrl.length > URL_MAX_SIZE) return null;

  const response = await fetch(fileUrl);
  return response.blob();
};

/**
 * @param bytes
 * @returns
 * Converts a number of bytes into a human-readable format using appropriate units (Bytes, Kb, Mb).
 *
 * The function uses base 1024 for conversions (i.e., 1 Kb = 1024 Bytes) and supports units up to Megabytes (Mb).
 * It rounds the resulting value to have two decimal places.
 *
 * @param {number} bytes - The number of bytes to be converted.
 * @returns {string} A string representing the converted value with the appropriate unit, e.g., "1 Mb" or "1 Kb".
 *
 */
export const formatBytes = (bytes: number): string => {
  const units = ['Bytes', 'Kb', 'Mb'];
  if (bytes === 0) return '0 Bytes';

  const base = 1024;
  const i = Math.floor(Math.log(bytes) / Math.log(base));

  const value = bytes / base ** i;
  return `${value.toFixed(2)} ${units[i]}`;
};
